import React from 'react';

import { InboxPEOStaff } from 'src/components/inbox';

export const InboxPagePEOStaff: React.FC = () => {
  return <InboxPEOStaff />;
};
